import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getCoach, updateCoach } from '../utils/coaches';

function CoachSettingsSection({ userId, coachId }) {
  const [coach, setCoach] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!coachId) {
      setLoading(false);
      return;
    }
    getCoach(coachId)
      .then(setCoach)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [coachId]);

  const handleUpdate = async (updates) => {
    if (!coach) return;
    try {
      const updated = await updateCoach(coach.id, updates);
      setCoach(updated);
    } catch (err) {
      console.error('[CoachSettings] Update error:', err);
    }
  };

  if (!coachId || loading || !coach) return null;

  const landingUrl = `${window.location.origin}/coach/${coach.slug}`;
  const markupBlocked = (coach.markupPerMonth || 0) > 0 && !coach.stripeAccountId;

  return (
    <div id="settings-coach-section" className="settings-section-wrapper">
      <h3 className="settings-section-header">TEAM / COACHING</h3>
      <div className="dashboard-card settings-section-card" style={{ marginBottom: '24px' }}>
        <h4 style={{ marginBottom: '4px', fontSize: '18px' }}>{coach.name}</h4>
        {coach.ageGroup && (
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '13px', margin: '0 0 16px 0' }}>{coach.ageGroup}</p>
        )}

        <div className="settings-row" style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
          <span className="settings-row-label">Team Page</span>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap', marginTop: '8px' }}>
            <input
              type="text"
              readOnly
              value={landingUrl}
              className="settings-input"
              style={{ flex: 1, minWidth: '200px', fontSize: '14px' }}
            />
            <button
              type="button"
              className="c-ripple"
              onClick={() => navigator.clipboard.writeText(landingUrl)}
              style={{ padding: '8px 16px', background: '#FF0000', color: 'white', border: 'none', fontSize: '14px' }}
            >
              Copy
            </button>
          </div>
        </div>

        <div className="settings-form-item" style={{ marginTop: '24px' }}>
          <label className="settings-form-label">Add per athlete per month ($0–$5)</label>
          <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.6)', marginBottom: '8px' }}>
            Pass through at base rate ($0) or add up to $5 — you keep the difference. Stripe required when adding.
          </p>
          <select
            value={coach.markupPerMonth ?? 0}
            onChange={(e) => {
              const val = parseInt(e.target.value, 10);
              if (val > 0 && markupBlocked) return;
              handleUpdate({ markupPerMonth: val });
            }}
            className="settings-select"
            disabled={markupBlocked}
            style={{ minWidth: '120px' }}
          >
            {[0, 1, 2, 3, 4, 5].map((n) => (
              <option key={n} value={n}>${n}</option>
            ))}
          </select>
          {markupBlocked && (
            <p style={{ fontSize: '12px', color: '#FF0000', marginTop: '8px' }}>
              Connect Stripe to charge more than base rate. (Coming soon)
            </p>
          )}
        </div>

        <div className="settings-form-item" style={{ marginTop: '16px', padding: '12px', background: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
          <span className="settings-row-label">Stripe Connect</span>
          <span className="settings-row-value">{coach.stripeAccountId ? 'Connected' : 'Not connected'}</span>
          <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.6)', marginTop: '4px' }}>Required when charging more than base. (Coming soon)</p>
        </div>

        <Link
          to={`/${userId}/coach/${coach.id}`}
          className="settings-row"
          style={{ marginTop: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
        >
          <span className="settings-row-label">View Roster</span>
          <span className="settings-row-chevron">›</span>
        </Link>
      </div>
    </div>
  );
}

export default CoachSettingsSection;
